export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पता जांचें"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पता दर्ज करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ब्लॉकचेन चुनें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जांच करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कम जोखिम"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मध्यम जोखिम"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उच्च जोखिम"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ब्लैकलिस्ट में नहीं"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["दूसरा पता जांचें"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PDF डाउनलोड करें"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["वापस"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रदाता चुनें"])}
}